var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWorkspaceCreate = function SvgIconWorkspaceCreate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd",
    clipPath: "url(#icon_workspace_create_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.656 2.375c.26 0 .469.21.469.469V15.03a.469.469 0 0 1-.937 0V2.844c0-.26.21-.469.468-.469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.875 2.844c0-.26.21-.469.469-.469h10.312a.469.469 0 1 1 0 .938H2.344a.47.47 0 0 1-.469-.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.344 2.375c.259 0 .469.21.469.469V15.03a.469.469 0 1 1-.938 0V2.844c0-.26.21-.469.469-.469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.875 15.031c0-.259.21-.469.469-.469h10.312a.469.469 0 1 1 0 .938H2.344a.47.47 0 0 1-.469-.469M2.862.76a.47.47 0 0 1 .42-.26h8.437c.177 0 .34.1.419.26l.938 1.874a.47.47 0 0 1-.42.679H2.344a.47.47 0 0 1-.42-.679zm.709.678-.469.937h8.796l-.469-.937z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15.031c0-.259.21-.469.469-.469H14.53a.469.469 0 1 1 0 .938H.47A.47.47 0 0 1 0 15.031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.174 12.3a1.875 1.875 0 0 1 2.652 0c.351.35.549.828.549 1.325v1.406c0 .26-.21.469-.469.469H6.094a.47.47 0 0 1-.469-.469v-1.406c0-.497.198-.974.55-1.326m.663.662a.94.94 0 0 1 1.326 0M4.688 4.953a.234.234 0 1 0 0-.469v-.468a.703.703 0 1 0 0 1.406z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.688 4.016a.703.703 0 1 1 0 1.406v-.469a.234.234 0 1 1 0-.469zM7.5 4.953a.234.234 0 1 0 0-.469v-.468a.703.703 0 0 0 0 1.406z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.016a.703.703 0 0 1 0 1.406v-.469a.234.234 0 1 1 0-.469zM10.313 4.953a.234.234 0 0 0 0-.469v-.468a.703.703 0 0 0 0 1.406z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.313 4.016a.703.703 0 0 1 0 1.406v-.469a.234.234 0 0 1 0-.469zM4.688 7.766a.234.234 0 1 0 0-.47v-.468a.703.703 0 0 0 0 1.406z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.688 6.828a.703.703 0 0 1 0 1.406v-.468a.234.234 0 1 1 0-.47zM7.5 7.766a.234.234 0 1 0 0-.47v-.468a.703.703 0 0 0 0 1.406z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.828a.703.703 0 0 1 0 1.406v-.468a.234.234 0 1 1 0-.47zM10.313 7.766a.234.234 0 0 0 0-.47v-.468a.703.703 0 0 0 0 1.406z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.313 6.828a.703.703 0 0 1 0 1.406v-.468a.234.234 0 0 1 0-.47zM4.688 10.578a.234.234 0 1 0 0-.469v-.468a.703.703 0 0 0 0 1.406z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.688 9.64a.703.703 0 0 1 0 1.407v-.469a.234.234 0 1 1 0-.469zM7.5 10.578a.234.234 0 1 0 0-.469v-.468a.703.703 0 0 0 0 1.406z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.64a.703.703 0 0 1 0 1.407v-.469a.234.234 0 1 1 0-.469zM10.313 10.578a.234.234 0 1 0 0-.469v-.468a.703.703 0 0 0 0 1.406z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.313 9.64a.703.703 0 0 1 0 1.407v-.469a.234.234 0 1 1 0-.469z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_workspace_create_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h15v15H0z"
  })))));
};
export default SvgIconWorkspaceCreate;